export { ImageWrapper as default } from './ImageWrapper';
